export const getCsrftoken = ():string => {
    const cookies = document.cookie.split(';')
    var result = ""
    for (let item of cookies) {
        if (item.trim().startsWith("csrftoken=")) {
            result = item.trim().replace('csrftoken=', '')
        }
    }
    return result
}